import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import { useCurrentCompanyId } from "hooks/auth";

/**
 * Discards an unsent ghost/draft invite (the cancel path of the two-step invite
 * flow). Hard-deletes server-side; guarded to unsent drafts only.
 */
const deleteDraft = async (userId: number): Promise<void> => {
  await apiV1.delete(`users/${userId}/invite/draft`);
};

export const useDeleteDraftMutation = () => {
  const queryClient = useQueryClient();
  const companyId = useCurrentCompanyId();

  return useMutation<void, Error, number>({
    mutationFn: deleteDraft,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users", companyId] });
    },
  });
};
